// extracted by mini-css-extract-plugin
export default {"container":"Ol-z","disabled":"Pl-z","subtotal":"Ql-z","legal":"Rl-z"};